import React from 'react';
import AuditLogPage from '../../features/audit/pages/AuditLogPage';
import { AppShell, PageContainer } from '../../features/ui-system';

const AdminAuditLog = () => {
  return (
    <AppShell>
      <PageContainer>
      <AuditLogPage />
                </PageContainer>
    </AppShell>
  );
};

export default AdminAuditLog;


